import _cloneDeep from 'lodash/cloneDeep'
import _filter from 'lodash/filter'
import _orderBy from 'lodash/orderBy'
// import _remove from 'lodash/remove'
import _uniqBy from 'lodash/uniqBy'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import { getRange } from '@/utils/dateRanges.js'

const moment = extendMoment(Moment)

const PREFERRED_DATE_NAME = 'preferred_date_name'
const defaultDateName = 'Last 7 days'
let preferredDateName = localStorage.getItem(PREFERRED_DATE_NAME)
preferredDateName = preferredDateName || defaultDateName

let dateRange = getRange(preferredDateName)
if (!dateRange) {
  dateRange = getRange(defaultDateName)
  preferredDateName = defaultDateName
}

// initial state
const state = {
  filterDateRange: moment.range(
    dateRange.array[0],
    dateRange.array[1]
  ),
  selectedDateRange: preferredDateName,
  filtersActiveProductDetailPage: [],
  filtersActiveProductsPage: []
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {
  filterDateRangeAssign (state, filterDateRange) {
    state.filterDateRange = _cloneDeep(filterDateRange)
  },
  filtersActiveProductDetailPageAdd (state, filter) {
    // add to array
    state.filtersActiveProductDetailPage.push(filter)

    // remove duplicates
    state.filtersActiveProductDetailPage = _uniqBy(state.filtersActiveProductDetailPage, 'id')

    // sort by title
    state.filtersActiveProductDetailPage = _orderBy(state.filtersActiveProductDetailPage, 'title')
  },
  filtersActiveProductDetailPageAssign (state, filtersActive) {
    state.filtersActiveProductDetailPage = _cloneDeep(filtersActive)
  },
  filtersActiveProductDetailPageRemove (state, id) {
    // remove active filter by id
    state.filtersActiveProductDetailPage = _filter(state.filtersActiveProductDetailPage, (filter) => {
      return filter.id !== id
    })

    // sort by title
    state.filtersActiveProductDetailPage = _orderBy(state.filtersActiveProductDetailPage, 'title')
  },
  filtersActiveProductDetailPageRemoveAll (state) {
    // reset the array
    state.filtersActiveProductDetailPage = []
  },
  filtersActiveProductsPageAdd (state, filter) {
    // add to array
    state.filtersActiveProductsPage.push(filter)

    // remove duplicates
    state.filtersActiveProductsPage = _uniqBy(state.filtersActiveProductsPage, 'id')

    // sort by title
    state.filtersActiveProductsPage = _orderBy(state.filtersActiveProductsPage, 'title')
  },
  filtersActiveProductsPageAssign (state, filtersActive) {
    state.filtersActiveProductsPage = _cloneDeep(filtersActive)
  },
  filtersActiveProductsPageRemove (state, id) {
    // remove active filter by id
    state.filtersActiveProductsPage = _filter(state.filtersActiveProductsPage, (filter) => {
      return filter.id !== id
    })

    // sort by title
    state.filtersActiveProductsPage = _orderBy(state.filtersActiveProductsPage, 'title')
  },
  filtersActiveProductsPageRemoveAll (state) {
    // reset the array
    state.filtersActiveProductsPage = []
  },
  selectedDateRangeAssign (state, selectedDateRange) {
    if (selectedDateRange !== '') {
      localStorage.setItem(PREFERRED_DATE_NAME, selectedDateRange)
    }
    state.selectedDateRange = selectedDateRange
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/js/store/modules/ui.js